import { parseISO } from 'date-fns';
import { dissoc, isEmpty, isNil, overProp, propOr } from '../../utils/fp';
import * as rules from '../rules';
import { isDefaultTimeDimensionInverted, sdmxPeriodBoundaries } from '../settings';

export const getObservationCount = constraintsArtefact =>
  propOr([], 'annotations', constraintsArtefact).find(annotation => annotation.id === 'obs_count')
    ?.title;

export const getIsTimePeriodDisable = timePeriod => {
  return !timePeriod?.display || isNil(timePeriod);
};

export const getTimePeriodContraints = (isTimePeriodDisable, timePeriod, contentConstraints) => {
  if (isTimePeriodDisable) return null;
  return contentConstraints?.[timePeriod?.id];
};

export const getTimePeriodBoundaries = timePeriodContraints => {
  const bounds = propOr([], 'boundaries', timePeriodContraints);
  const bound = isNil(bounds[0]) || isNil(bounds[1]) ? sdmxPeriodBoundaries : bounds;
  return bound.map(date => (typeof date === 'string' ? parseISO(date) : date));
};

export const getTimePeriodArtefact = ({
  timePeriod,
  isTimePeriodDisable,
  timePeriodBoundaries,
}) => {
  if (isTimePeriodDisable) return null;
  return { ...timePeriod, timePeriodBoundaries };
};

export const getTime = ({ timePeriod, isTimePeriodInversed }) => {
  const timePeriodId = propOr('TIME', 'id', timePeriod);
  return {
    [timePeriodId]: isTimePeriodInversed || isDefaultTimeDimensionInverted,
  };
};

export const getFrequencyId = attrId => {
  const pMatch = attrId.match(/P([\d]+)([YMD])$/);
  if (pMatch) {
    const [, offset, scope] = pMatch;
    if (scope === 'D' && offset === '7') {
      return 'W';
    }
    if (scope === 'D' && offset === '1') {
      return 'D';
    }
    if (scope === 'M' && offset === '6') {
      return 'S';
    }
    if (scope === 'M' && offset === '3') {
      return 'Q';
    }
    if (scope === 'M' && offset === '1') {
      return 'M';
    }
    if (scope === 'Y') {
      return offset === '1' ? 'A' : `A${offset}`;
    }
    return null;
  }
  const ptMatch = attrId.match(/PT([\d]+)([HM])$/);
  if (ptMatch) {
    const [, offset, scope] = ptMatch;
    if (scope === 'H' && offset === '1') {
      return 'H';
    }
    if (scope === 'M' && offset === '60') {
      return 'H';
    }
    if (scope === 'M' && offset === '1') {
      return 'N';
    }
  }
  return null;
};

export const getFrequencyArtefact = ({ dimensions, attributes }) => {
  const freqDim = dimensions.find(rules.isFrequencyDimension);
  if (freqDim) {
    return freqDim;
  }
  const freqAttr = attributes.find(rules.isFrequencyAttribute);
  if (!freqAttr || isEmpty(freqAttr?.values || [])) {
    return undefined;
  }
  const withValues = overProp(
    'values',
    values =>
      values.reduce((acc, valueItem) => {
        const id = getFrequencyId(valueItem.id);
        if (isNil(id)) return acc;
        return [...acc, { ...valueItem, id }];
      }, []),
    freqAttr,
  );
  const timeFormatAttribute = { ...dissoc('index', withValues), isAttribute: true };

  if (isEmpty(timeFormatAttribute.values)) {
    return undefined;
  }
  return timeFormatAttribute;
};
